import { Box, styled } from "@mui/material";

const LotsContainer = styled(Box)(({ theme }) => ({
  gap: "24px",
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  "& .MuiPaper-root": {
    width: "262px",
  },

  [theme.breakpoints.up("md")]: {
    gap: "40px 24px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    "& .MuiPaper-root": {
      width: "100%",
    },
  },
}));

export { LotsContainer };
